import { render, staticRenderFns } from "./AdminRemarksBlock.vue?vue&type=template&id=488537e8&scoped=true"
import script from "./AdminRemarksBlock.vue?vue&type=script&lang=js"
export * from "./AdminRemarksBlock.vue?vue&type=script&lang=js"
import style0 from "./AdminRemarksBlock.vue?vue&type=style&index=0&id=488537e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488537e8",
  null
  
)

export default component.exports